import { render, staticRenderFns } from "./calculateBidScore.vue?vue&type=template&id=1faab6fa&scoped=true"
import script from "./calculateBidScore.vue?vue&type=script&lang=js"
export * from "./calculateBidScore.vue?vue&type=script&lang=js"
import style0 from "./calculateBidScore.vue?vue&type=style&index=0&id=1faab6fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faab6fa",
  null
  
)

export default component.exports